<template>
  <ClientOnly>
    <mux-player
      ref="mux"
      :playback-id
      :metadata-video-title="videoTitle"
      :metadata-viewer-user-id="viewerId"
      :class="{ visible }"
      nohotkeys
      accent-color="#F06F02"
      data-component-name="AppVideo.Player"
      @play="emit('play')"
      @pause="emit('pause')"
      @loadedmetadata="metaDataLoadHandler"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
// https://github.com/muxinc/elements/blob/main/packages/mux-player/REFERENCE.md#properties

import '@mux/mux-player';

type MuxPlayer = {
  play(): void;
  pause(): void;
  duration: number;
};

withDefaults(
  defineProps<{
    visible?: boolean;
    playbackId: string;
    viewerId?: string;
    videoTitle?: string;
    controls?: boolean;
  }>(),
  {
    visible: true,
    controls: true,
  },
);

const emit = defineEmits<{
  play: [];
  pause: [];
  duration: [value: number];
}>();

const playerRef = useTemplateRef<MuxPlayer>('mux');

const metaDataLoadHandler = () => {
  if (!playerRef.value) return;

  emit('duration', Math.round(playerRef.value.duration));
};

defineExpose({
  play: () => playerRef.value?.play(),
  pause: () => playerRef.value?.pause(),
});
</script>

<style scoped lang="scss">
// https://docs.mux.com/guides/player-customize-look-and-feel#available-css-variables

[data-component-name='AppVideo.Player'] {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;

  position: relative;
  z-index: 0;
  aspect-ratio: 16 / 9;

  --seek-live-button: none;
  --seek-backward-button: none;
  --seek-forward-button: none;
  --playback-rate-button: none;
  --captions-button: none;
  --airplay-button: none;
  --mute-button: none;
  --cast-button: none;
  --pip-button: none;
  --controls: v-bind(" controls ? 'inherit' : 'none' ");

  &.visible {
    opacity: 1;
    pointer-events: all;
  }
}
</style>
